<script>
import Layout from "../../layouts/main";

import appConfig from "@/app.config";
import {pagingModel} from "@/models/pagingModel";
import {CONSTANTS} from "@/helpers/constants";
import Multiselect from "vue-multiselect";
import {thongTinLienLacModel} from "@/models/thongTinLienLacModel";
import {notifyModel} from "@/models/notifyModel";
import {CURRENT_USER} from "@/helpers/currentUser";

export default {
  page: {
    title: "Thông tin liên lạc",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, Multiselect},
  data() {
    return {
      title: "Thông tin liên lạc",
      model: thongTinLienLacModel.baseJson(),
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      filter: {
        content: null,
        donVi: null,
        chucVu: null,
      },
      isBusy: false,
      fields: [
        {
          key: 'STT',
          label: 'STT',
          class: 'td-stt',
          sortable: false,
          thClass: 'hidden-sortable',
          thStyle: {width: '30px', minWidth: '30px'},
        },
        {
          key: "lastName",
          label: "Họ và tên đệm",
          sortable: true,
          thStyle: "text-align:left",
          thClass: 'hidden-sortable',
        },
        {
          key: "firstName",
          label: "Tên",
          sortable: true,
          thStyle: "text-align:left",
          thClass: 'hidden-sortable',
        },
        {
          key: "phoneNumber",
          label: "Số điện thoại",
          sortable: true,
          thStyle: "text-align:left",
          thClass: 'hidden-sortable',
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thStyle: "text-align:left",
          thClass: 'hidden-sortable',
        },
        {
          key: "donVi",
          label: "Đơn vị",
          sortable: true,
          thClass: 'hidden-sortable',
        },
        {
          key: "chucVu",
          label: "Chức vụ",
          sortable: true,
          thStyle: {width: '200px', minWidth: '100px'},
          thClass: 'hidden-sortable',
        },
        {
          key: 'process',
          label: '',
          thStyle: {width: '50px', minWidth: '50px'},
          class: " text-center btn-process ",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        }
      ],
      optionsChucVu: [],
      optionsDonVi: [],
      showModal: false,
      submitted: false,
      currentUserPermissions: CURRENT_USER.PERMISSIONS
    };
  },
  created() {
    this.getDonVi();
    this.getChucVu();
  },
  methods: {
    checkCapNhatThongTinLienLac() {
      var checkVT = this.currentUserPermissions.find(x => x == CONSTANTS.CAP_NHAT_THONG_TIN_LIEN_LAC);

      if (checkVT) {
        return true;
      }
      return false;
    },
    handleCloseModal() {
      this.model = thongTinLienLacModel.baseJson()
      this.showModal = false;
    },
    handleShowModal(item) {
      this.showModal = true;
      this.model = Object.assign({}, item);
    },
    async getChucVu() {
      try {
        await this.$store.dispatch("chucVuStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsChucVu = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async getDonVi() {
      try {
        await this.$store.dispatch("donViStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsDonVi = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.filter.content,
        donVi: this.filter.donVi,
        chucVu: this.filter.chucVu,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("thongTinLienLacStore/getPagingParams", params)
        return promise.then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            let data = resp.data;
            this.totalRows = data.totalRows
            let items = data.data
            this.numberOfElement = items.length
            this.loading = false
            return items || []
          } else {
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });
      if (
          this.model.id != 0 &&
          this.model.id != null &&
          this.model.id
      ) {
        //Update model
        await this.$store.dispatch("thongTinLienLacStore/update", this.model).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showModal = false;
            this.model = thongTinLienLacModel.baseJson()
            this.$refs.tblList.refresh();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        })
      }
      loader.hide()
    }
  }
}
</script>
<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> {{ title }}</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button v-b-toggle.collapseSearch variant="light"
                          class="btn w-md btn-primary-outline me-2" size="sm">
                  <i class="fas fa-caret-down align-middle me-2"></i>
                  Tìm kiếm
                </b-button>
              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Nội dung -->
                    <div class="flex-grow-1 me-2">
                      <label>Từ khoá</label>
                      <input
                          size="sm"
                          type="text"
                          name="untyped-input"
                          class="form-control"
                          v-model="filter.content"
                          placeholder=""
                      />
                    </div>
                    <!-- Đơn vị soạn-->
                    <div class="flex-grow-1 me-2">
                      <label>Đơn vị</label>
                      <multiselect
                          v-model="filter.donVi"
                          :options="optionsDonVi"
                          track-by="id"
                          label="ten"
                          placeholder="Chọn đơn vị"
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                      ></multiselect>
                    </div>
                    <!-- Loại văn bản -->
                    <div class="flex-grow-1 me-2">
                      <label> Chức vụ</label>
                      <multiselect
                          v-model="filter.chucVu"
                          :options="optionsChucVu"
                          track-by="id"
                          selectLabel="Nhấn vào để chọn"
                          deselectLabel="Nhấn vào để xóa"
                          class="helo"
                          label="ten"
                          placeholder="Chọn chức vụ"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="table-responsive-sm">
                  <b-table
                      class="datatables custom-table"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :filter="filter"
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                      tbody-tr-class="b-table-vbd"
                  >
                    <template v-slot:cell(process)="data">
                      <button type="button" class="btn btn-detail btn-sm" data-toggle="tooltip"
                              data-placement="bottom"
                              title="Chi tiết" v-b-toggle="'collapse-' + data.item.id" @click="data.toggleDetails">
                        <i class="fas fa-eye "></i>
                      </button>
                    </template>
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(ten)="data">
                      {{ data.item.ten }}
                    </template>
                    <template v-slot:cell(donVi)="data">
                      <div v-if="data.item.donVi">
                        {{ data.item.donVi.ten }}
                      </div>
                    </template>
                    <template v-slot:cell(chucVu)="data">
                      <div v-if="data.item.chucVu">
                        {{ data.item.chucVu.ten }}
                      </div>
                    </template>
                    <template #row-details="data">
                      <b-collapse :id="`collapse-${data.item.id}`" class="">
                        <b-card class="m-0 show-detail-vbd cs-close-tabs">
                          <button
                              v-if="checkCapNhatThongTinLienLac()"
                              type="button"
                              size="sm"
                              class="btn btn-outline btn-sm p-0 item-close-tabs"
                              style="margin-right: 30px; margin-top: 4px"
                              data-toggle="tooltip" data-placement="bottom" title="Cập nhật"
                              @click="handleShowModal(data.item)"
                          >
                            <i class="fas fa-pencil-alt me-1 fs-4 text-primary"></i>
                          </button>
                          <button
                              type="button"
                              size="sm"
                              class="btn btn-outline btn-sm p-0 item-close-tabs"
                              data-toggle="tooltip" data-placement="bottom" title="Đóng"
                              v-b-toggle="'collapse-' + data.item.id"
                              @click="data.toggleDetails"
                          >
                            <i class="fas fa-plus me-1 item-icon fs-3 text-danger"></i>
                          </button>
                          <b-tabs content-class="p-3 bg-white">
                            <b-tab active class="border-0">
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="fas fa-file-alt"></i>
                                </span>
                                <span class="d-none d-sm-inline-block">Thông tin</span>
                              </template>
                              <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                  <div v-if="data.item.userName" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary"> Mã công chức/viên chức:</p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.userName }}</p>
                                  </div>
                                  <div v-if="data.item.lastName && data.item.firstName"
                                       class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary"> Họ và tên: </p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.lastName }}
                                      {{ data.item.firstName }}</p>
                                  </div>
                                  <div v-if="data.item.phoneNumber" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary"> Số điện thoại:</p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.phoneNumber }}</p>
                                  </div>
                                  <div v-if="data.item.email" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary">Email:</p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.email }}</p>
                                  </div>
                                  <div v-if="data.item.address" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary"> Địa chỉ:</p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.address }}</p>
                                  </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">

                                  <div v-if="data.item.donVi" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary"> Đơn vị:</p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.donVi.ten }}</p>
                                  </div>
                                  <div v-if="data.item.chucVu" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary"> Chức vụ:</p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.chucVu.ten }}</p>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 ">
                                  <div v-if="data.item.trichYeu" class="mb-1">
                                    <p class="mb-0 text-primary">Trích yếu:</p>
                                    <p class="mb-0 text-black-2a p-2"
                                       style="border: 0.5px dotted #ccc; border-radius: 3px;"
                                       :inner-html.prop="data.item.trichYeu">
                                    </p>
                                  </div>
                                </div>
                                <div v-if="data.item.filePDF" class="col-md-6 col-sm-12">
                                  <p class="mb-0 text-primary">File đã ký:</p>
                                  <div class="mb-1 d-flex file-box justify-content-start flex-column">
                                    <div v-for="(value, index) in data.item.filePDF" :key="index" class="mb-1 me-2"
                                         style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px;">
                                      <a style="cursor: pointer" :href="`${apiUrl}files/view/${value.fileId}`"
                                         class=" fw-medium">
                                        <i
                                            class="fas fa-cloud-download-alt text-primary mx-2"></i>
                                        [Tải về]
                                      </a>
                                      <a style="cursor: pointer" @click="handleShowFile(value.fileId)"
                                         class="text-danger fw-medium">
                                        [Xem]
                                      </a>
                                      <span style="font-weight: 500; color: #2F93E0" class="px-2">
                                        {{ value.fileName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="data.item.file" class="col-md-6 col-sm-12">
                                  <p class="mb-0 text-primary"> Văn bản trình ký:</p>
                                  <div class="mb-1 d-flex file-box">
                                    <div v-for="(value, index) in data.item.file" :key="index" class="mb-1 me-2"
                                         style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px;">
                                      <a style="cursor: pointer" :href="`${apiUrl}files/view/${value.fileId}`"
                                         class=" fw-medium">
                                        <i
                                            class="fas fa-cloud-download-alt text-primary mx-2"></i>
                                        [Tải về]
                                      </a>
                                      <a style="cursor: pointer" @click="handleShowFile(value.fileId)"
                                         class="text-danger fw-medium">
                                        [Xem]
                                      </a>
                                      <span style="font-weight: 500; color: #2F93E0" class="px-2">
                                        {{ value.fileName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="data.item.phuLucDinhKem" class="col-md-12 col-sm-12">
                                  <p class="mb-0 text-primary"> Hồ sơ kèm theo:</p>
                                  <div class="mb-1 d-flex file-box">
                                    <div
                                        v-for="(value, index) in data.item.phuLucDinhKem" :key="index"
                                        class="mb-1 me-2"
                                        style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px;"
                                    >
                                      <a style="cursor: pointer" :href="`${apiUrl}files/view/${value.fileId}`"
                                         class=" fw-medium">
                                        <i
                                            class="fas fa-cloud-download-alt text-primary mx-2"></i>
                                        [Tải về]
                                      </a>
                                      <span v-if="value.ext=='.pdf'">
                                         <a style="cursor: pointer" @click="handleShowFile(value.fileId)"
                                            class="text-danger fw-medium">
                                        [Xem]
                                      </a>
                                      </span>

                                      <span
                                          style="font-weight: 500; color: #2F93E0"
                                          class="px-2"
                                      >
                                        {{ value.fileName }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-tab>
                          </b-tabs>
                        </b-card>
                      </b-collapse>
                    </template>

                  </b-table>
                  <template v-if="isBusy">
                    <div align="center">Đang tải dữ liệu</div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>
                <!-- Paginnation -->
                <div>
                  <div class="row mb-2">
                    <div class="col-sm-12 col-md-6">
                      <div style="display: flex; justify-content: start; align-items: center">
                        <div style="margin-right: 20px" class="">
                          <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                              Hiện
                              <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                                             :options="pageOptions"></b-form-select>&nbsp;dòng
                            </label>
                          </div>

                        </div>
                        <div class="">
                          <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage">
                          </b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
        v-model="showModal"
        :title="model.userName + ' - '+ model.fullName"
        title-class="text-black font-18"
        body-class="p-3"
        hide-footer
        centered
        no-close-on-backdrop
        size="lg"
    >
      <form @submit.prevent="handleSubmit"
            ref="formContainer"
      >
        <div class="row">
          <div class="col-6">
            <input type="hidden" v-model="model.id"/>
            <div class="mb-3">
              <label class="text-left"> Email</label>
              <input
                  v-model.trim="model.email"
                  type="text"
                  class="form-control"
                  placeholder="Nhập email"
              />
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label class="text-left"> Số điện thoại</label>
              <input
                  v-model.trim="model.phoneNumber"
                  type="text"
                  class="form-control"
                  placeholder="Nhập số điện thoại"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="mb-3">
              <label class="text-left"> Địa chỉ</label>
              <textarea
                  v-model="model.address"
                  type="text"
                  class="form-control"
                  placeholder="Nhập địa chỉ"
              > </textarea>
            </div>
          </div>
        </div>
        <div class="text-end pt-2">
          <b-button variant="light" class="w-md" @click="handleCloseModal">
            Đóng
          </b-button>
          <b-button type="submit" variant="primary" class="ms-1 w-md">Lưu
          </b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>
<style>
.title-capso {
  font-weight: bold;
  color: #00568C;
}

.content-capso {
  color: #00568C;
}

.capso-container {
  margin-top: 10px;
  display: flex;
  padding: 0px;
}

.hidden-sortable:after,
.hidden-sortable:before {
  display: none !important;
}
</style>

<style>
.show-detail-vbd .card-body {
  padding: 0;
}

.show-detail-vbd {
  background-color: #e6f0fb;
  border: 1px solid #e6f0fb;
  border-radius: 5px;
  margin: 10px;
}

@media only screen and (max-width: 768px) {
  .show-detail-vbd {
    margin: 0px;
  }
}

.show-detail-vbd .card-body {
  padding: 0;
}

.show-detail-vbd .card-body .nav-tabs .nav-link {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border: none;
  background: transparent;
  color: #055E8F;
  border-radius: 5px;
}

.show-detail-vbd .card-body .nav-tabs .nav-link.active {
  background: #055E8F;
  color: #fff;
}

.show-detail-vbd .card-body .nav-tabs {
  border-bottom: none;
}

.text-black-2a {
  color: #2a2a2a;
}

.text-black {
  color: #000;
}

.hidden-sortable:after,
.hidden-sortable:before {
  display: none !important;
}

@media only screen and (max-width: 768px) {

  /* Force table to not be like tables anymore */
  .cs-xulyvbdi table,
  .cs-xulyvbdi thead,
  .cs-xulyvbdi tbody,
  .cs-xulyvbdi th,
  .cs-xulyvbdi td,
  .cs-xulyvbdi tr {
    display: block;
    padding: 5px 0px !important;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .cs-xulyvbdi thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .cs-xulyvbdi tr {
    border: 1px solid #f5f5f5;
    margin-bottom: 5px;
  }

  .cs-xulyvbdi .table-bordered > :not(caption) > * {
    border-width: 0.5px;
    border-radius: 5px;
  }

  .cs-xulyvbdi .table-bordered {
    border: none;
  }

  .cs-xulyvbdi .table-bordered th:first-child,
  .cs-xulyvbdi .table-bordered td:first-child {
    border-top: none;
  }

  .cs-xulyvbdi .table-bordered th,
  .cs-xulyvbdi .table-bordered td {
    border: none;
    border-top: 1px solid #f5f5f5;
  }

  .b-table-vbd > td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    min-height: 30px !important;
    padding-left: 20% !important;
    padding: 5px 0px;
  }

  .b-table-details.b-table-vbd > td {
    padding-left: 0% !important;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 5px;
    left: 6px;
    padding-right: 10px;
    white-space: nowrap;
  }

  .btn-process {
    padding: 0px !important;
  }

  .btn-process .btn {
    background-color: rgb(0 89 144 / 0.1);
    width: 20%;
    margin: 5px;
  }

  .file-box {
    flex-direction: column;
  }

  /*
  Label the data
  */
  .b-table-vbd > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(2):before {
    content: "Họ tên đệm";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(3):before {
    content: "Tên ";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(4):before {
    content: "Số điện thoại";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(5):before {
    content: "Email";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(6):before {
    content: "Đơn vị";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(7):before {
    content: "Chức vụ";
    font-weight: bold;
    color: #00568c;
  }
}

@media only screen and (max-width: 768px) {
  .b-table-vbd > td {
    padding-left: 95px !important;
  }
}


#modal-tuchoiky .modal-content {
  border: 2px solid #4299e1;
  border-radius: 5px;
}

.cs-close-tabs {
  position: relative;
}

.item-close-tabs {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-close-tabs:hover {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  width: 30px;
  height: 30px;
}

.item-icon {
  transform: rotate(135deg);
  color: #fff;
  width: 24px;
  height: 26px;
  position: absolute;
  top: 1px;
  right: -1px;
}

.multiselect {
  min-height: 34px;
}

.multiselect__select {
  height: 34px;
}

</style>
